import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { IRIBOForm1 } from "./RIBOForms.types";
import { api } from "../../../api/api";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../../messages/messagesActions";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IBalanceSheetStatement } from "../BalanceSheetStatements/BalanceSheetStatements.types";

export const FETCH_RIBO_FORMS_LIST_PROGRESS = "FETCH_RIBO_FORMS_LIST_PROGRESS";
export const FETCH_RIBO_FORMS_LIST_SUCCESS = "FETCH_RIBO_FORMS_LIST_SUCCESS";
export const FETCH_RIBO_FORMS_LIST_FAILURE = "FETCH_RIBO_FORMS_LIST_FAILURE";

export const fetchRIBOFormsListProgress = () =>
  action(FETCH_RIBO_FORMS_LIST_PROGRESS);

export const fetchRIBOFormsListSuccess = (data: IRIBOForm1[]) =>
  action(FETCH_RIBO_FORMS_LIST_SUCCESS, { data });

export const fetchRIBOFormsListFailed = (errorMessage: string) =>
  action(FETCH_RIBO_FORMS_LIST_FAILURE, { errorMessage });

export const fetchRIBOFormsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchRIBOFormsListProgress());
      let finalUrl = `/accounting/get-account-position-report?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-position-report?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IRIBOForm1[] = res.data.data;

      dispatch(fetchRIBOFormsListSuccess(data));
    } catch (err: any) {
      dispatch(fetchRIBOFormsListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

// export const addAccountingRecievableTrustAysnc =
//   (
//     data: IRecievableTrust,
//     onCallback: (isSuccess: boolean) => void
//   ): ThunkAction<void, IStoreState, {}, AnyAction> =>
//   async (dispatch, getState) => {
//     try {
//       dispatch(saveLoaderProgress());
//       await api.post("/accounting/edit-account-receivable-trust", {
//         ...data,
//       });
//       let message = "RecievableTrust saved successfully.";
//       dispatch(
//         showMessage({
//           type: "success",
//           message: message,
//           displayAs: "snackbar",
//         })
//       );
//       onCallback(true);
//     } catch (err: any) {
//       onCallback(false);
//       dispatch(
//         showMessage({
//           type: "error",
//           message: err.response.data.message,
//           displayAs: "snackbar",
//         })
//       );
//     } finally {
//       dispatch(saveLoaderCompleted());
//     }
//   };

export const FETCH_RIBO_FORMS_PROGRESS = "FETCH_RIBO_FORMS_PROGRESS";
export const FETCH_RIBO_FORMS_SUCCESS = "FETCH_RIBO_FORMS_SUCCESS";
export const FETCH_RIBO_FORMS_FAILURE = "FETCH_RIBO_FORMS_FAILURE";

export const fetchRIBOFormsProgress = () => action(FETCH_RIBO_FORMS_PROGRESS);

export const fetchRIBOFormsSuccess = (data: IRIBOForm1) =>
  action(FETCH_RIBO_FORMS_SUCCESS, { data });

export const fetchRIBOFormsFailed = (errorMessage: string) =>
  action(FETCH_RIBO_FORMS_FAILURE, { errorMessage });

export const fetchRIBOFormsSuccessAsync =
  (report_code: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchRIBOFormsProgress());
      const res = await api.get(`/accounting/get-account-position-report?report_code=${report_code}`);
      const data: IRIBOForm1[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchRIBOFormsSuccess(data[0]));
      } else {
        dispatch(fetchRIBOFormsFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
      }
    } catch (err: any) {
      dispatch(fetchRIBOFormsFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };


  export const upsertRIBOForm1 =
    (
      data: IRIBOForm1,
      onCallback: (isSuccess: boolean, data?: IRIBOForm1) => void
    ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());
        const res = await api.post("/accounting/edit-account-position-report", {
          ...data,
        });
        const message = "RIBO Form 1 saved successfully.";
        dispatch(
          showMessage({
            type: "success",
            message: message,
            displayAs: "snackbar",
          })
        );
        onCallback(true, res.data.data);
      } catch (err: any) {
        onCallback(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const fetchBalanceSheetForRIBOAsync =
  (
    toDate: string,
    onCallback: (isSuccess: boolean, rows?: IBalanceSheetStatement[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/accounting/get-balance-sheet-data-v2?from_date=2000-01-01&to_date=${toDate}`
      );
      const rows: IBalanceSheetStatement[] = res.data?.data || [];
      onCallback(true, rows);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message || "Failed to fetch balance sheet.",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_RIBO_FORMS_STATE = "CLEAR_RIBO_FORMS_STATE";
export const clearRIBOFormsState = () => action(CLEAR_RIBO_FORMS_STATE);
